type QuickMessageSuggestion = {
  id?: string;
  display_name: string;
  shortcut: string;
  template_body: string;
};

type QuickMessageSuggestionsProps = {
  activeIndex: number;
  items: QuickMessageSuggestion[];
  onSelect: (item: QuickMessageSuggestion) => void;
};

export default function QuickMessageSuggestions({
  activeIndex,
  items,
  onSelect,
}: QuickMessageSuggestionsProps) {
  if (items.length === 0) return null;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-lg overflow-hidden">
      <div className="px-3 py-2 border-b border-slate-100 bg-slate-50 text-[11px] uppercase tracking-wide text-slate-500">
        Quick messages
      </div>
      <div className="max-h-64 overflow-y-auto" role="listbox" aria-label="Quick messages">
        {items.map((item, index) => (
          <button
            key={item.id ?? `${item.shortcut}-${index}`}
            type="button"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onSelect(item)}
            role="option"
            aria-selected={index === activeIndex}
            className={`w-full px-3 py-2.5 text-left transition-colors border-b border-slate-100 last:border-b-0 ${
              index === activeIndex ? "bg-slate-100" : "hover:bg-slate-50"
            }`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="text-sm font-medium text-slate-800">{item.display_name}</span>
              <span className="text-xs font-mono text-slate-500">/{item.shortcut}</span>
            </div>
            <p className="mt-1 text-xs text-slate-500 whitespace-pre-wrap line-clamp-2">
              {item.template_body}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}
